import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginModel } from '../models/login.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private http: HttpClient) { }
  // private baseUrl = 'https://globalsources-erp-staging-23176447.dev.odoo.com/odoo';
  // private baseUrl = 'https://globalsources-erp-staging-24532743.dev.odoo.com/odoo';
  // private baseUrl = 'https://globalsources-erp.odoo.com/odoo';
  private baseUrl = environment.apiUrl;
  
  signupEmployee(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + '/employee/signup', payload);
  }

  authenticate(loginRequest: LoginModel): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: loginRequest
    };
    return this.http.post(this.baseUrl + '/employee/signin', body);
  }

  getLeaveCategories(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    return this.http.post(this.baseUrl + '/get/leavecategory', body);
  }

  getLeaveTypes(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    return this.http.post(this.baseUrl + '/get/leavetype', body);
  }

  getAvailableContractLeave(employee_no: any, leave_categ_id: any): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { employee_no, leave_categ_id }
    };
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/available/leaves', body, { headers });
  }

  applyLeave(payload: any): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/leaverequest/create', payload, { headers });
  }

  getLeaveStatus(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/get/leave/requests', body, { headers });
  }

  applySalaryAdvance(payload: any): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/create/salary/advance', payload, { headers });
  }

  getSalaryAdvanceRequestStatus(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/get/salary/advance', body, { headers });
  }

  applyLoan(payload: any): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/create/loan', payload, { headers });
  }

  getLoanRequestStatus(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/get/loan', body, { headers });
  }

  getGuarantor(): Observable<any> {
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/get/guarantor', body, { headers });
  }

  // signupEmployee(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + '/vendor/signup', payload);
  // }

  changePassword(payload: any): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    return this.http.post(this.baseUrl + '/employee/change_password', payload, { headers });
  }
}
